export const SUCCESS           = 'success';
export const DANGER            = 'danger';
export const WARNING           = 'warning';
export const ATTENTION         = 'attention';
export const ATTENTION_INFO    = 'attention-info';
export const ATTENTION_WARNING = 'attention-warning';
export const ATTENTION_DANGER  = 'attention-danger';
